<template>
  <a-modal
    :visible="modalVisible"
    :footer="null"
    @cancel="handleCloseModal"
    width="1000px"
  >
    <h1 class="modal-title">{{ data.name || '' }}</h1>
    <ActivitiesTable :tableData="data.refList"></ActivitiesTable>
  </a-modal>
</template>

<script>
import ActivitiesTable from '@/components/ActivitiesTable'
export default {
  name: 'LinkDetailModal',
  components: { ActivitiesTable },
  data() {
    return {
      data: {},
      modalVisible: false,
    }
  },
  methods: {
    showModal(data) {
      this.modalVisible = true
      this.data = data
    },
    handleCloseModal() {
      this.modalVisible = false
      this.data = {}
    },
  },
}
</script>

<style lang="scss" scoped></style>
